import React from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

function FemaleStaffReport() {
  const location = useLocation();
  const { femaleStaffData } = location.state || { femaleStaffData: [] };
const navigate = useNavigate();
const udiseNumber = localStorage.getItem("udiseNumber");
   const [schoolData, setSchoolData] = useState(null); 
  
const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

      useEffect(() => {
                 const storedLanguage = localStorage.getItem('language') || 'English';
                 setLanguage(storedLanguage);
               }, []);

     useEffect(() => {
        fetchSchoolData(); 
      }, );


  const handleClose = () => {
    navigate(-1); // Change '/profile' to the actual path of your profile page
};

const fetchSchoolData = () => {
  const firebaseDatabaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`;

  fetch(firebaseDatabaseUrl)
    .then(response => response.json())
    .then(data => {
      setSchoolData(data); 
    })
    .catch(error => {
      console.error('Error fetching school data from Firebase:', error);
    });
};

const handlePrint = () => {
  const printContent = document.querySelector('.modal-content');
  
  if (printContent) {
    const cloneContent = printContent.cloneNode(true);

    const schoolName = cloneContent.querySelector('p'); 
    const otherDetails = cloneContent.querySelectorAll('p'); 

    otherDetails.forEach((p, index) => {
      if (index !== 0) { 
        p.style.fontWeight = 'normal'; 
      }
    });
    
    if (schoolName) {
      schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`; // Increase the font size and set top margin
    }

      const printWindow = window.open('', '', 'height=500,width=800');
      const table = printContent.querySelector('table');
      // const title = document.querySelector('h1');
      printWindow.document.write(`
        <style>
          body {
            font-family: Arial, sans-serif;
            font-size: 12px;
            border: 1px solid black;
            padding: 15px;
          }
            #print-content{
                margin: 20px; /* Add margin to the modal content */
              }
                 .modal-content {
                margin: 20px; /* Add margin to the modal content */
              }
            @page{
            margin: 3mm;
            }
                @media print {
             .print-btn {
             display: none;
             }
}
             .print-title {
              font-size: 20px;
              text-align: center;
              color: white;
              padding: 5px;
              background-color: black;
              border: 1px solid black;
              width: 20%;
              border-radius: 6px;
              margin: auto;
  }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          th, td {
            border: 1px solid black;
            padding: 10px;
            text-align: left;
          }
          th {
            background-color:#ecf0f1;
          }
          .print-container {
            border: none;
            background-color: transparent;
          }
          .main-content-of-page {
            border: none;
            background-color: transparent;
          }
        </style>
      `);
      // printWindow.document.write(title.outerHTML);
      printWindow.document.write(table.outerHTML);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error("Element with ID 'print-content' not found.");
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f4f7f6' }}>
      <div
        className="main-content-of-page"
        style={{
          flex: 1,
          padding: '20px',
          marginLeft: '250px', // Adjust based on sidebar width
          backgroundColor: '#ffffff',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px',
        }}
>
          
          <div style={{ 
  border: '2px solid black', // Increased border width
  padding: '10px', 
  margin: 'auto', 
  width: '60%', 
  boxShadow: '0 0 20px rgba(0, 0, 0, 0.3)', // Increased box shadow size
  marginTop: '20px', 
  borderRadius: '10px', 
  height: '760px', 
  overflowY: 'auto' 
}}>
 
 <div style={{
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: '100%',
  marginBottom: '10px',
}}>
  <button
    className="print-btn"
    onClick={handlePrint}
    style={{
      backgroundColor: '#03365e',
      color: '#ffffff',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      fontSize: '16px',
      marginRight: '10px',
    }}
  >
    Print
  </button>
  <button
    style={{
      backgroundColor: '#dc3545',
      color: '#fff',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      fontSize: '20px',
      fontWeight: 'bold',
    }}
    onClick={handleClose}
  >
    X
  </button>
</div>




  <style>
    {`
      @media print {
        body * {
          visibility: hidden; /* Hide everything by default */
        }
        .main-content-of-page, .main-content-of-page * {
          visibility: visible; /* Show only the main content */
        }
        .main-content-of-page {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          border-radius: 0 !important;
          width: 100%;
        }
        .print-container {
          border: none; /* Remove border for print */
          padding: 0; /* Remove padding for print */
          margin: 0; /* Remove margin for print */
        }
       .print-title {
    font-size: 20px;
    text-align: center;
    color: white;
    padding: 5px;
    background-color: black;
    border: 1px solid black;
    width: 20%;
    border-radius: 6px;
    margin: auto;
  }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 10px;
        }
        th, td {
          padding: 8px;
          text-align: center;
          border: 1px solid #ddd;
        }
        th {
          background-color: #ecf0f1 !important;
          color: black !important;
          -webkit-print-color-adjust: exact; /* Ensure background color prints */
        }
        button {
          display: none; /* Hide the print button in print view */
        }
      }
    `}
  </style>

  <div className='modal-content'>
    <table
      style={{
        width: '100%',
        borderCollapse: 'collapse',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        margin: 'auto',
        border: 'none'
      }}
    >
         <thead>
                    {schoolData && (
                      <tr>
                        <th colSpan="3" style={{

                          color: 'black',
                          padding: '5px',
                          borderRadius: '10px 10px 0 0',
                          textAlign: 'center',
                          lineHeight: '0.4',
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          fontSize: '13px'
                        }}>
                          <p><strong><h5> {schoolData.schoolName}</h5></strong></p>
                          <p>{schoolData.sansthaName}</p>
                          <p>{language === "English" ? "Taluka:" : "तालुका:"} {schoolData.taluka} , {language === "English" ? "Jilha:" : "जिल्हा:"} {schoolData.jilha} </p>
                          <p>{language === "English" ? "Mobile Number:" : "मोबाइल नंबर:"} {schoolData.mobileNumber} , {language === "English" ? "Email:" : "ईमेल:"} {schoolData.email}</p>
                          <h1 
                          className="print-title"
                          style={{ margin:'auto',textAlign: 'center', color: '#2c3e50', fontSize: '28px', marginBottom: '30px',border:'1px solid black',width:'240px', height:'40px',fontWeight:'bold',fontSize:'18px',backgroundColor:'black',color:'white',padding:"10px",borderRadius:'4px' }}>
                         {language === "English" ? " Female Staff Report " : "महिला कर्मचारी अहवाल"}</h1>
                        </th>
                      </tr>
                    )}
          <th style={{ padding: '12px', textAlign: 'center', border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Sr.No  " : "अनु.क्र."}</th>
          <th style={{ padding: '12px', textAlign: 'center', border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black', }}>{language === "English" ? "Mobile Number " : "मोबाईल नंबर"}</th>
          <th style={{ padding: '12px', textAlign: 'center', border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Name " : "नाव"}</th>
      </thead>
      <tbody>
        {femaleStaffData.map((employee, index) => (
          <tr
            key={index}
            style={{
              backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
              transition: 'background-color 0.3s ease',
            }}
          >
            <td style={{ padding: '12px', textAlign: 'center', border: '1px solid black' }}>{index + 1}</td>
            <td style={{ padding: '12px', textAlign: 'center', border: '1px solid black' }}>{employee.mobile}</td>
            <td style={{ padding: '12px', textAlign: 'center', border: '1px solid black' }}>{employee.name}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>
      </div>
    </div>
  );
}

export default FemaleStaffReport;